// extracted by mini-css-extract-plugin
module.exports = {"graph":"AllStats_graph__3ZygJ","title":"AllStats_title__2jMS4"};